/* eslint-disable @next/next/no-img-element */
import { LanguageText } from "./LanguageText";

function MemberPortrait({
  src,
  alt,
  width,
  height,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
}) {
  return (
    <div className="about-member-portrait">
      <img src={src} alt={alt} width={width} height={height} />
    </div>
  );
}

export function TeamDirectory() {
  return (
    <>
      <section className="page-hero about-hero">
        <p className="eyebrow">ABOUT US · 关于我们</p>
        <LanguageText
          as="h1"
          zh="关于 TrypCell Atlas"
          en="About TrypCell Atlas"
        />
        <LanguageText
          as="p"
          zh="TrypCell Atlas 是由沈阳农业大学分子寄生虫课题组建设的双语锥虫科研数据门户，面向全球研究人员整理可追溯的公开图谱、数据集和来源记录。"
          en="TrypCell Atlas is a bilingual Trypanosoma research data portal developed by the Molecular Parasitology Research Group at Shenyang Agricultural University for the global research community."
        />
      </section>

      <section className="section about-team-section">
        <header className="about-section-heading">
          <div>
            <p>OUR TEAM</p>
            <LanguageText as="h2" zh="团队成员" en="Our team" />
          </div>
          <LanguageText
            as="p"
            zh="姓名、机构、联系方式和照片只在本人或实验室确认后公开。"
            en="Names, affiliations, contact details and portraits are published only after confirmation by the person or laboratory."
          />
        </header>

        <div className="about-member-grid">
          <article className="about-member-card">
            <MemberPortrait
              src="/team/qilong-li.jpg"
              alt="李其龙教授 / Professor Qilong Li"
              width={940}
              height={940}
            />
            <div className="about-member-copy">
              <LanguageText
                as="h3"
                zh="李其龙"
                en="Qilong Li"
              />
              <LanguageText
                as="strong"
                zh="教授、博士生导师 · TrypCell Atlas 科学负责人"
                en="Professor & PhD Supervisor · Scientific Lead, TrypCell Atlas"
              />
              <LanguageText
                as="p"
                zh="主要研究疟原虫、弓形虫和锥虫等病原寄生虫与宿主的相互作用，以及抗寄生虫药物的免疫调节作用。"
                en="Researches host interactions with pathogenic parasites, including Plasmodium, Toxoplasma and Trypanosoma, and the immunomodulatory effects of antiparasitic drugs."
              />
              <div className="about-member-links">
                <LanguageText
                  as="span"
                  zh="分子寄生虫课题组 · 沈阳农业大学动物科学与医学学院"
                  en="Molecular Parasitology Research Group · College of Animal Science and Veterinary Medicine, Shenyang Agricultural University"
                />
                <a href="mailto:liqilong@syau.edu.cn">liqilong@syau.edu.cn</a>
                <a
                  href="https://orcid.org/0000-0002-8645-3566"
                  target="_blank"
                  rel="noreferrer"
                >
                  ORCID ↗
                </a>
                <a
                  href="https://liqilong111.github.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LanguageText zh="个人学术主页 ↗" en="Academic website ↗" />
                </a>
                <a
                  href="https://myxy.syau.edu.cn/info/1170/6561.htm"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LanguageText
                    zh="学校官方主页 ↗"
                    en="Official university profile ↗"
                  />
                </a>
              </div>
            </div>
          </article>

          <article className="about-member-card">
            <MemberPortrait
              src="/team/jiaming-dong.jpg"
              alt="董家鸣 / Jiaming Dong"
              width={960}
              height={1442}
            />
            <div className="about-member-copy">
              <LanguageText as="h3" zh="董家鸣" en="Jiaming Dong" />
              <LanguageText
                as="strong"
                zh="硕士研究生 · TrypCell Atlas 网站维护"
                en="Master's Student · TrypCell Atlas Website Maintenance"
              />
              <LanguageText
                as="p"
                zh="负责 TrypCell Atlas 网站维护。"
                en="Maintains the TrypCell Atlas website."
              />
              <div className="about-member-links">
                <LanguageText
                  as="span"
                  zh="分子寄生虫课题组 · 沈阳农业大学"
                  en="Molecular Parasitology Research Group · Shenyang Agricultural University"
                />
                <a href="mailto:1924396516@qq.com">1924396516@qq.com</a>
                <LanguageText
                  as="span"
                  zh="成员本人提供并授权公开"
                  en="Member-provided and authorised for publication"
                />
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="section about-contact-section">
        <div>
          <p className="section-number">CONTACT &amp; CONTRIBUTE</p>
          <LanguageText
            as="h2"
            zh="联系项目或贡献数据"
            en="Contact the project or contribute data"
          />
          <LanguageText
            as="p"
            zh="如需提交研究、报告数据问题或申请加入项目，请通过提交页面留下可核实的信息。"
            en="To submit a study, report a data issue or ask to join the project, use the submission page and provide verifiable information."
          />
        </div>
        <div className="about-contact-actions">
          <a className="button button-dark" href="/submit/">
            <LanguageText zh="打开提交页面" en="Open Submit" />
          </a>
          <a className="button" href="/guide/">
            <LanguageText zh="阅读使用指南" en="Read the Guide" />
          </a>
        </div>
      </section>
    </>
  );
}
